import { createSelector } from "reselect"
import { get, isEmpty } from "lodash"

const getUserInfo = (state) => get(state, "global.data.resetPasswordUser.data")

export const getToken = (_, props) => {
  return get(props, "params.token")
}

export const getValidToken = createSelector(
  [getUserInfo, getToken],
  (userInfo, token) => {
    if (isEmpty(userInfo)) {
      return null
    }
    return token
  })

export const getMfaEnabled = createSelector(
  [getUserInfo],
  (userInfo) => get(userInfo, "mfaEnabled", false),
)

export const getPasswordExpired = createSelector(
  [getUserInfo],
  (userInfo) => get(userInfo, "passwordExpired", false),
)
